<template>
  <div class="container">
    <b-alert variant="success" show>{{ message }}</b-alert>
    <br>
  </div>
</template>

<script>
export default {
  props: ['message'],
};
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Alert.vue